const ATTACHMENTS_CONFIG = {
    MAX_ITEMS_COUNT: 15,
    MAX_FILE_SIZE_MB: 10,
    FILE_TYPES: {
        'image/jpeg': [],
        'image/png': [],
        'image/heic': [],
        'application/pdf': [],
    },
    FILE_TYPES_LABELS: '.pdf, .heic, .jpeg, .png',
};

const proccessedTimesheetSearchKeysDict = {
    clinicianName: 'Clinician Name',
    recruiterName: 'Recruiter',
    salespersonName: 'Salesperson',
    bookingName: 'Booking Number',
    accountName: 'Account Name',
};

const searchOptions = Object.entries(proccessedTimesheetSearchKeysDict).map(([key, name]) => ({
    name,
    value: key,
}));

const returnProcessedTimesheetsColumns = (pageType) => {
    switch (pageType) {
        case 'processedTimesheets':
            return [
                {
                    label: 'Status',
                    key: 'status',
                    size: 1.5,
                },
                {
                    label: 'Processed Timesheet',
                    key: 'processedTimesheet',
                    size: 0.5,
                    sortable: false,
                },
                {
                    label: 'Recruiter',
                    key: 'recruiter',
                    size: 1,
                },
                {
                    label: 'Salesperson',
                    key: 'salesperson',
                    size: 1,
                },
                {
                    label: 'Clinician',
                    key: 'clinician',
                    size: 1,
                },
                {
                    label: 'Booking',
                    key: 'booking',
                    size: 1,
                },
                {
                    label: 'Needs Review Reason',
                    key: 'needsReviewReason',
                    size: 2,
                },
                {
                    label: 'TC Comments',
                    key: 'teamCoordinatorComments',
                    size: 2,
                },
                {
                    label: 'Approval Date',
                    key: 'approvalDate',
                    size: 1,
                },
                {
                    label: 'Month Posted',
                    key: 'monthPosted',
                    size: 1,
                },
                {
                    label: 'Clinician Comments',
                    key: 'clinicianComments',
                    size: 2,
                },
                {
                    label: 'Account',
                    key: 'accountName',
                    size: 1,
                },
                {
                    label: 'Week Ending Date',
                    key: 'weekEndingDate',
                    size: 1,
                },
                {
                    label: 'Special Processing',
                    key: 'specialProcessing',
                    size: 1,
                },
                {
                    label: 'Primary Work Location',
                    key: 'primaryWorkLocation',
                    size: 1,
                },
                {
                    label: 'Account Coordinator',
                    key: 'accountCoordinator',
                    size: 1,
                },
            ];
        case 'processedTimesheetsBP':
            return [
                {
                    label: 'Status',
                    key: 'status',
                    size: 1.5,
                },
                {
                    label: 'Processed Timesheet',
                    key: 'processedTimesheet',
                    size: 0.5,
                    sortable: false,
                },
                {
                    label: 'Number of work locations',
                    key: 'numberOfWorkLocations',
                    size: 0.5,
                },
                {
                    label: 'Booking',
                    key: 'booking',
                    size: 1,
                },
                {
                    label: 'Special Processing',
                    key: 'specialProcessing',
                    size: 1,
                },
                {
                    label: 'AB5',
                    key: 'ab5',
                    size: 0.5,
                },
                {
                    label: 'Clinician',
                    key: 'clinician',
                    size: 1,
                },
                {
                    label: 'Needs Review Reason',
                    key: 'needsReviewReason',
                    size: 2,
                },
                {
                    label: 'Team Coordinator Comments',
                    key: 'teamCoordinatorComments',
                    size: 2,
                },
                {
                    label: 'Week Ending Date',
                    key: 'weekEndingDate',
                    size: 1,
                },
                {
                    label: 'Original Pay',
                    key: 'originalPay',
                    size: 1,
                },
                {
                    label: 'Approval Date',
                    key: 'approvalDate',
                    size: 1,
                },
                {
                    label: 'Month Posted',
                    key: 'monthPosted',
                    size: 1,
                },
            ];
        case 'processedTimesheetsTC':
            return [
                {
                    label: 'Status',
                    key: 'status',
                    size: 1.5,
                },
                {
                    label: 'Processed Timesheet',
                    key: 'processedTimesheet',
                    size: 0.5,
                    sortable: false,
                },
                {
                    label: 'Recruiter',
                    key: 'recruiter',
                    size: 1,
                },
                {
                    label: 'Salesperson',
                    key: 'salesperson',
                    size: 1,
                },
                {
                    label: 'Clinician',
                    key: 'clinician',
                    size: 1,
                },
                {
                    label: 'Booking',
                    key: 'booking',
                    size: 1,
                },
                {
                    label: 'Needs Review Reason',
                    key: 'needsReviewReason',
                    size: 2,
                },
                {
                    label: 'TC Comments',
                    key: 'teamCoordinatorComments',
                    size: 2,
                },
                {
                    label: 'Clinician Comments',
                    key: 'clinicianComments',
                    size: 2,
                },
                {
                    label: 'Account',
                    key: 'accountName',
                    size: 1,
                },
                {
                    label: 'Week Ending Date',
                    key: 'weekEndingDate',
                    size: 1,
                },
                {
                    label: 'Special Processing',
                    key: 'specialProcessing',
                    size: 1,
                },
                {
                    label: 'Primary Work Location',
                    key: 'primaryWorkLocation',
                    size: 1,
                },
                {
                    label: 'Account Coordinator',
                    key: 'accountCoordinator',
                    size: 1,
                },
            ];
        default:
            return [];
    }
};

const rateTypesEnumApi = {
    perDay: 'PerDay',
    perHour: 'PerHour',
    perWeek: 'PerWeek',
    perBookingDay: 'PerBookingDay',
    perConsult: 'PerConsult',
    perBooking: 'PerBooking',
    each: 'Each',
    notApplicable: 'NotApplicable',
};

const rateTypesEnum = {
    perDay: 'Per Day',
    perHour: 'Per Hour',
    perWeek: 'Per Week',
    perBookingDay: 'Per Booking Day',
    perConsult: 'Per Consult',
    perBooking: 'Per Booking',
    each: 'Each',
    notApplicable: 'Not Applicable',
};

function rateTypesEnumApiToDisplay(value) {
    if (!value) return '-';
    const matchingKey = Object.keys(rateTypesEnumApi).find(
        (key) => rateTypesEnumApi[key] === value
    );
    if (matchingKey && rateTypesEnum[matchingKey]) {
        return rateTypesEnum[matchingKey];
    }
    return value;
}

function getRateTypeKeyFromApiValue(apiValue) {
    if (!apiValue) return null;

    const matchingKey = Object.keys(rateTypesEnumApi).find(
        (key) => rateTypesEnumApi[key] === apiValue
    );

    return matchingKey || null;
}

function isPtsReadOnly(status) {
    return (
        status === 'Outdated' ||
        status === 'Posted' ||
        status === 'Invoiced' ||
        status === 'Cancelled'
    );
}

export {
    ATTACHMENTS_CONFIG,
    proccessedTimesheetSearchKeysDict,
    searchOptions,
    rateTypesEnumApiToDisplay,
    getRateTypeKeyFromApiValue,
    returnProcessedTimesheetsColumns,
    rateTypesEnumApi,
    rateTypesEnum,
    isPtsReadOnly,
};
